import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		display: flex;
		align-items: center;
		gap: 8px;

		& > h2 {
			${({theme}) => theme.font.large_bold};
		}

		& > input {
			width: 50%;
			padding: 8px 16px;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}

		& > select {
			width: 50%;
			padding: 8px 16px;
			${({theme}) => theme.font.extra_small};
			border: 1px solid ${({theme}) => theme.color.grey3};
			border-radius: 4px;
		}
	`,
}
export default Style
